import { AfterViewInit, Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Policy } from '../../../../../shared/models/info/policy';
import { SwPartNumber } from '../../../../../shared/models/sw-part-number/sw-part-number';
import { IfPolicySatisfiedDirective } from '../../../../directives/if-policy-satisfied.directive';
import { ImportIconComponent } from '../../../icons/import-icon/import-icon.component';
import { ImportType } from '../../../lists/sw-part-number/sw-part-number-accordion/import-type';
import { initFlowbite } from 'flowbite';
import { CloseIconComponent } from '../../../icons/close-icon/close-icon.component';
import { AgentActionDirective } from '../../../../directives/agent-action.directive';

@Component({
  selector: 'app-import-popover',
  imports: [IfPolicySatisfiedDirective, ImportIconComponent, CloseIconComponent, AgentActionDirective],
  templateUrl: './import-popover.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './import-popover.scss',
})
export class ImportPopover implements AfterViewInit {
  @Input() public swPartNumber?: SwPartNumber;
  @Output() public importClicked = new EventEmitter<{ swPartNumber: SwPartNumber; importType: ImportType }>();

  protected readonly popoverTargetId = `import-popover-${crypto.randomUUID()}`;
  protected readonly policy = Policy;
  protected readonly importType = ImportType;
  protected isOpen = false;

  public ngAfterViewInit(): void {
    initFlowbite();
  }
}
